import * as yup from 'yup';
import { CustomerType } from '../../AccountOpening.meta';
import { legalFirstNameValidation, legalLastNameValidation } from '../../fields/Name/Name.meta';
import {
  cityValidation,
  postalCodeValidation,
  stateValidation,
  streetAddressLine1Validation,
} from '../../fields/Address/Address.meta';
import { dobValidation } from '../../fields/DateOfBirth/DateOfBirth.meta';
import { ssnValidation } from '../../fields/Ssn/Ssn.meta';
import { phoneNumberValidation } from '../../fields/Phone/Phone.meta';
import { companySymbolsValidation } from '../../fields/ControlPerson/ControlPerson.meta';
import { brokerFirmNameValidation } from '../../fields/BrokerFirmName/BrokerFirmName.meta';
import { snapIdValidation } from '../../fields/Letter407Upload/Letter407Upload.meta';
import {
  companyNameValidation,
  jobTitleValidation,
} from '../../fields/EmploymentStatus/EmploymentStatus.meta';
import { eSignedValidation } from '../../fields/ESigned/ESigned.meta';
import { emailValidation } from '../../fields/Email/Email.meta';
import { beneficiaryValidation } from '../../fields/Beneficiary/Beneficiary.meta';

export const validation = yup.object().shape({
  primaryApplicant: yup.object().shape({
    legalFirstName: legalFirstNameValidation,
    legalLastName: legalLastNameValidation,
    dob: dobValidation,
    ssn: ssnValidation,
    phoneNumber: phoneNumberValidation,
    email: emailValidation,
    streetAddressLine1: streetAddressLine1Validation,
    city: cityValidation,
    state: stateValidation,
    postalCode: postalCodeValidation,
    employerName: companyNameValidation,
    positionEmployed: jobTitleValidation,
  }),

  secondApplicant: yup.object().shape({
    legalFirstName: yup
      .string()
      .nullable()
      .when('$customerType', {
        is: CustomerType.Joint,
        then: legalFirstNameValidation,
      }),
    legalLastName: yup
      .string()
      .nullable()
      .when('$customerType', {
        is: CustomerType.Joint,
        then: legalLastNameValidation,
      }),
  }),

  companySymbols: companySymbolsValidation,

  brokerDealerfirmName: brokerFirmNameValidation,

  snapId: snapIdValidation,

  eSigned: yup
    .boolean()
    .nullable()
    .when('$isUserClient', {
      is: true,
      then: eSignedValidation,
    }),

  retirementAccountBeneficiaryInfo: yup.object().when('$customerType', {
    is: CustomerType.Ira,
    then: beneficiaryValidation,
  }),
});
